import { Fieldset, If } from '@paytrace/pt-skel/Component'
import { getLegacyDomain } from '@paytrace/pt-skel/Helper'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { MANAGE_ENHANCED_DATA_PAGE_ROUTE } from '../../../Helper/EnhancedData/Constants'
import { AlertIcon } from '../../Icons/AlertIcon'
import { AmountsDisplay } from './AmountsDisplay'
import { ManageEnhancedDataBanner } from './ManageEnhancedDataBanner'
import { ResponseInformation } from './ResponseInformation'
import { SurchargeAmounts, TransactionPageProps } from './ResponsePage'
import { ViewAndEmailReceipt } from './SaveAndEmailReceipt'

export function PartiallyApprovedView ({
  props,
  orderId,
  surchargeAmounts,
  settleAmount,
}: { props: TransactionPageProps, orderId: string, surchargeAmounts: SurchargeAmounts, settleAmount: number }) {
  const handleCreateCustomer = () => {
    const EMPTY_CUSTOMER_ID = -1
    window.location.href = (props.customer_id === EMPTY_CUSTOMER_ID)
      ? `${getLegacyDomain()}/mcust.pay?new=Y&tranxid=${orderId}`
      : `${getLegacyDomain()}/mcust.pay?tranxid=${orderId}&cid=${String(props.customer_id)}`
  }
  const notApprovedAmount = Number(props.amount) - settleAmount
  const navigate = useNavigate()

  return (
    <Fieldset className={'entire-view'}>
      <div className="uid-tranx-app-clear clear"></div>

      <div className="partial-banner-container">
        <div className="uid-tranx-app-warning center giant-text status-banner-partial">
          Payment Partially Approved
        </div>
        <div className="partial-details-box">
          <p className="partial-details-text">
            $ {settleAmount.toFixed(2)} was partially approved and processed.
          </p>
          <p className="partial-details-text bold">
            $ {notApprovedAmount.toFixed(2)} was not processed.
          </p>
          <div className="partial-btn-group">
            <button
              className="partial-btn-remaining"
              onClick={() => console.debug('Initiate new transaction for remaining amount')}
            >
              New Transaction for Remaining Amount
            </button>
            <button
              className="partial-btn-void"
              onClick={() => console.debug('Initiate void for partial transaction')}
            >
              Void Partial Transaction
            </button>
          </div>
        </div>
      </div>

      <ResponseInformation
        title="Approval Information:"
        responseMessage={props.approval_message || props.response_message}
        orderId={orderId}
        amountDisplay={<AmountsDisplay props={props} isPartialApproval={true} approvedAmount={settleAmount} notApprovedAmount={notApprovedAmount}/>}
        actionButtons={
          <>
            <button className="action-btn" onClick={handleCreateCustomer}>Create Customer From Transaction</button>
          </>
        }
        approvalCode={props.approval_code}
      >
        <tr>
          <td className="response-info-label"><strong>Requested Amount:</strong></td>
          <td className="uid-tranx-app-transaction-amount">${Number(props.amount).toFixed(2)}</td>
        </tr>
        <tr>
          <td className="response-info-label"><strong>Approved Amount:</strong></td>
          <td className="uid-tranx-app-transaction-amount">${settleAmount.toFixed(2)}</td>
        </tr>
        <tr>
          <td className="response-info-label"><strong>Not Approved:</strong></td>
          <td className="uid-tranx-app-transaction-amount text-error-color">${notApprovedAmount.toFixed(2)}</td>
        </tr>
      </ResponseInformation>

      <br />

      <ViewAndEmailReceipt
        orderId={orderId}
        merchantId={props.merchant}
        initialEmails={props.emails}
      />

       <If is={props.showEnhancedData}>
            <ManageEnhancedDataBanner
                title="Manage Enhanced Data to help qualify for better rates."
                subText="In order for this transaction to be eligible for better processing rates, line item data is required. "
                buttonText="Manage Enhanced Data"
                onButtonClick={() => {
                  navigate(`${MANAGE_ENHANCED_DATA_PAGE_ROUTE}?tranxid=${orderId}`)
                }}
            />
          </If>

      <div className="warning warning-banner">
        <AlertIcon />
        &nbsp;Warning - Please do not click the back or refresh buttons as this may cause your transaction to be duplicated.
      </div>
    </Fieldset>
  )
}
